import axios from 'axios'
import store from '@/store/store'
import EventBus from '@/store/eventBus'
import apiUrls from '../../API_URLS.json'
import getUseServer from '@/utils/getServer'
import i18n from "@/i18n/i18n";

const send = async (url, method, options = {}, notification = true) => {
    try {
        const ajaxRequest = store.getters.ajaxRequest

        if(ajaxRequest && !ajaxRequest.url.includes(apiUrls.user.get_user) && url !== apiUrls.user.get_user) {
            ajaxRequest.cancel('Cancel request')
        }

        let server = getUseServer()

        await store.dispatch('LOADER_START')

        if (options.server) {
            server = options.server
        }

        url = server.value + url

        if (!options.headers) options.headers = {}
        options.headers.authorization = localStorage.getItem(server.name)

        options.headers['x-app-locale'] = i18n.locale === 'ua' ? 'uk' : i18n.locale
        options.headers['server-name'] = server.name

        if (options.token) {
            options.headers.authorization = options.token
        }

        if (!options.headers.authorization) {
            delete options.headers.authorization
        }

        if (options.data) {
            Object.entries(options.data).map(([key, value]) => {
                if (typeof value === 'string') options.data[key] = value.trim()
            })
        }

        const d = await axios({ method, url, ...options })

        if (method !== 'GET' && notification) await store.dispatch('ADD_SUCCESS', d.data.message)
        await store.dispatch('LOADER_STOP')

        return Promise.resolve(d)
    } catch (e) {
        if(e.response && e.response.status === 401) {
            EventBus.$emit('emitPopupEvent', {type: 'close'})
            setTimeout(async () => {
                await store.dispatch('AUTH_ERROR', e.response.data.message)
            }, 0)
        } else if (e.response && e.response.status === 403) {
            await store.dispatch('AUTH_ERROR', e.response.data.message)
        } else if (e.response && e.response.status === 400) {
            store.commit('SET_VALID_ERROR', e.response.data.errors || e.response.data.message || e.response.data.result)
            store.commit('SET_ERROR', e.response.data.errors || e.response.data.message || e.response.data.result)
        } else if (e.response && e.response.status === 403) {
            await store.dispatch('ADD_PERM_ERROR', e.response.data.message)
        } else if (e.response) {
            await store.dispatch('ADD_ERROR', e.response.data.message)
        } else if (e.request) {
            await store.dispatch('ADD_ERROR', 'Unknown error')
        } else {
            if (!axios.isCancel(e)) {
                await store.dispatch('ADD_ERROR', e.message)
            }
        }

        await store.dispatch('LOADER_STOP')
        return Promise.reject(e)
    }
}

export default send
